import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function AICenter() {
  const page = getSemanticPageByPath('/ai-center');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
